<route>
{
  "meta": {
    "customSite": true
  }
}
</route>
<template>
  <Register />
</template>

<script>
import Register from '@implicit-web/auth/src/pages/m/register.vue';

export default {
  name: 'Registerf',
  components: { Register },
};
</script>
